import { createAction } from 'redux-actions'

const ENTITY = 'SEARCH'
export const stateKey = ENTITY.toLowerCase()

export const setQuickSearchCriteria = createAction(`${ENTITY}/QUICK/SET`, (payload) => payload)
export const clearQuickSearchCriteria = createAction(`${ENTITY}/QUICK/CLEAR`)

export const setDetailSearchCriteria = createAction(`${ENTITY}/DETAIL/SET`, (searchType, criteria) => ({ searchType, criteria }))
export const clearDetailSearchCriteria = createAction(`${ENTITY}/DETAIL/CLEAR`, (searchType) => ({ searchType }))
